
import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import CartProduct from "./CartProduct";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Shop.css";

export default function CartPage({ navigateTo }) {
  const { shoppingCart, emptyShoppingCart } = useContext(CartContext);

  const totalPrice = shoppingCart.reduce((total, product) => {
    return total + (product.price * product.quantity);
  }, 0);

  return (
    <>
      <Header navigateTo={navigateTo} />

      <section className="container content-section">
        <h2 className="section-header">سبد خرید شما</h2>

        {shoppingCart.length === 0 ? (
          <div className="empty-cart">
            <p>سبد خرید شما خالی می باشد</p>
            <a
              href="/"
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault();
                navigateTo("shop");
              }}
            >
              ← صفحه اصلی
            </a>
          </div>
        ) : (
          <>
            {/* هدرهای جدول */}
            <div className="cart-header-row">
              <span className="cart-header cart-column">محصول</span>
              <span className="cart-header cart-column">قیمت</span>
              <span className="cart-header cart-column">تعداد</span>
            </div>

            {/* لیست محصولات داخل سبد */}
            <div className="cart-items-wrapper">
              {shoppingCart.map((product) => (
                <CartProduct
                  key={product.id}
                  id={product.id}
                  title={product.title}
                  price={product.price}
                  img={product.img}
                  quantity={product.quantity}
                />
              ))}
            </div>

            {/* نمایش قیمت کل */}
            <div className="cart-total">
              <strong>قیمت کل: {totalPrice} تومان</strong>
            </div>

            {/* دکمه‌های پایین صفحه */}
            <div className="cart-buttons">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => navigateTo("shop")}
              >
                 فروشگاه
              </button>

              <button
                className="btn btn-purchase"
                type="button"
                onClick={emptyShoppingCart}
              >
                خالی کردن سبد
              </button>

              <button
                className="btn btn-secondary checkout-btn"
                type="button"
                onClick={() => navigateTo("checkout")}
              >
                ثبت سفارش 
              </button>
              
            </div>
          </>
        )}
      </section>

      <Footer />
    </>
  );
}